module.exports = __webpack_public_path__ + "img/magic.0d24022c.png";